import { ref } from '@vue/composition-api';
import { fetchPortal } from '@lsfe/tools';
import { hPost, hGet } from '@mcfe/tools';

// 卖点是否为空
export const isNullSellPoint = ref(true);

// ai生成的数据
export const aiSellingData = ref({});

// 接口参数
export const aiParams = ref({});

// 调用ai接口
export const queryAiData = () => new Promise((resolve) => {
    const headers = { Authorization: 'Bearer 3f0a07b1c2d6f9b577e3a3f958e498471a9382001de7e0a84bbf0d438fc126d6' };
    hPost('/api/mc/gpt/sku/point', aiParams.value, { headers }).then((AISellPoints) => {
        aiSellingData.value = AISellPoints;
        resolve(aiSellingData.value);
    });
});

// 初始化参数
export const initAiSelling = async (data) => {
    try {
        isNullSellPoint.value = data.isNullSellPoint;

        // 获取商品基础信息
        let skuInfo = data.createNewReferData;
        if (!skuInfo) {
            const infoData = await hPost('/api/vss/shepherd/ProductSearchTService/mapSpuBaseBySkuId', {
                data: { skuBaseIdList: [data.skuId] },
            });
            skuInfo = {
                ...infoData?.spuBaseMap[data.skuId],
                ...infoData?.spuBaseMap?.[data.skuId]?.skuBaseList?.[0],
            };
        }

        // 并行请求所有需要的数据
        const [reviewList, pointConfig, buyRecom] = await Promise.all([
        // 获取评论列表
            hGet('/api/m/mallorder/review/querySkuReviewList', {
                skuId: data.skuId,
                offset: 0,
                limit: 30,
                labelCode: 0,
            }),

            // 获取模型配置
            fetchPortal('mall_nest_gpt_config')('generate_config'),

            // 获取买手推荐规则
            hPost('/api/vss/shepherd/VssBuyRecommendationRuleManageTService/queryBuyRecommendationRuleByBgCategoryId', {
                bgCategoryId: data.bgCategoryId,
            }),
        ]);

        // 处理图片OCR文本
        let imageText = '';
        if (data.descriptionPics && data.descriptionPics.length) {
            const picUrls = data.descriptionPics.length <= pointConfig.pic_length
                ? data.descriptionPics
                : data.descriptionPics.slice(0, pointConfig.pic_length);

            const res = await hPost('/api/vss/shepherd/VssProductAlgToolTService/getCachedOcrTextByScene', {
                picUrls,
                sceneType: 2,
            });
            imageText = (res || []).map((item) => {
                try {
                    // 解析 JSON 并获取 results_str 数组
                    const parsed = item && item.recognizeContent ? JSON.parse(item.recognizeContent) : {};
                    // 如果 results_str 是数组，则将其连接为字符串；否则返回空字符串
                    return Array.isArray(parsed.results_str) ? parsed.results_str.join(',') : (parsed.results_str || '');
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('OCR 文本解析失败:', e);
                    return '';
                }
            }).filter(Boolean).join(',');
        }

        // 提取需要的商品信息
        const {
            bgCategoryName, brandName, name, skuName, spuBaseId,
            skuSellPointContentList, specActual, skuExtAttrList,
        } = skuInfo;

        // 构建AI请求参数
        aiParams.value = {
            skuId: data.skuId,
            spuId: spuBaseId,
            skuName: name || skuName,
            specActual,
            bgCategoryName,
            bgCategoryId: data.bgCategoryId,

            // 处理卖点信息
            sellPoints: (skuSellPointContentList || [])
                .map((item) => item.sellPointContentName)
                .join(),

            // 处理评论信息
            comments: (reviewList?.reviewList || [])
                .map((item) => item.reviewBody)
                .filter(Boolean)
                .join(),

            // 处理扩展属性
            attrInfo: (skuExtAttrList || []).map((item) => ({
                attrName: item.attrName,
                value: (item.selectedValues || [])
                    .map((valueItem) => valueItem.value)
                    .join(),
            })),

            // 其他参数
            brandName,
            cleanComments: true,
            modelName: pointConfig?.model_name || 'gpt41',
            imageText,

            // 买手推荐相关参数
            sellPointDefinition: (buyRecom.sellPointDefineInfos || [])
                .map((item) => `${item.sellType}:${item.sellTypeDes}`)
                .join('>'),
            buyerRecommendationStyle: buyRecom.sellDescStyle,
            sellPointBlack: buyRecom.blacks,
            buyerRecommendationExample: buyRecom.sellDescExample,
            sellPointExample: (buyRecom.sellPointExamples || [])
                .map((item) => `${item.sellType}:${item.sellTypeDes}`)
                .join(','),
            otherInstructions: buyRecom.otherDes,
        };

        // 调用AI接口获取数据
        await queryAiData();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('初始化AI卖点数据失败:', error);
        throw error;
    }
};
